/**
 * PerformanceBar component export
 */

export { default } from "./PerformanceBarContainer";
